import React, { createContext, useContext, useMemo } from 'react';

export type AccessMode = 'manage' | 'view';
export const CENTER_VIEW_BANNER_HEIGHT = 34;

type AccessModeContextValue = {
    accessMode: AccessMode;
    isReadOnly: boolean;
};

const AccessModeContext = createContext<AccessModeContextValue>({
    accessMode: 'manage',
    isReadOnly: false,
});

export const AccessModeProvider = ({ authObject, children }: { authObject: any; children: React.ReactNode }) => {
    const value = useMemo<AccessModeContextValue>(() => {
        const isReadOnly = authObject?.accessMode === 'view' || authObject?.role === 'center_viewer';
        return { accessMode: isReadOnly ? 'view' : 'manage', isReadOnly };
    }, [authObject]);

    return <AccessModeContext.Provider value={value}>{children}</AccessModeContext.Provider>;
};

export const useAccessMode = () => useContext(AccessModeContext);
